<script>
    import { onMount } from 'svelte'
    import { TabSetX as TabSet } from '$lib/components/UI/'
    import OfertasSection from './OfertasSection.svelte'
    import ofertas from '$lib/services/collections/offers'
    onMount(() => {
        // Fetch offers data when the component mounts
        ofertas.init()
    })
</script>

<div class="container">
            <TabSet.Group>
                <TabSet.Tab label="Mis Ofertas">
                    <OfertasSection
                        customFilter={(item) => ['Ingresada', 'Revision Polaris'].includes(item.state)}
                    />
                </TabSet.Tab>
                <TabSet.Tab label="Adjudicadas">
                    <OfertasSection
                        title="Adjudicadas"
                        customFilter={(item) => ['Adjudicada', 'Remito adjuntado'].includes(item.state)}
                    />
                </TabSet.Tab>
                <TabSet.Tab label="Entregadas">
                    <OfertasSection
                        title="Entregadas"
                        customFilter={(item) => ['Entregado'].includes(item.state)}
                    />
                </TabSet.Tab>
                <TabSet.Tab label="Cambios de Costo">
                    <OfertasSection
                        title="Cambios de Costo"
                        customFilter={(item) => ['Solicitud de cambio de costo'].includes(item.state)}
                    />
                </TabSet.Tab>
                <TabSet.Tab label="Finalizadas">
                    <OfertasSection
                        title="Finalizadas"
                        customFilter={(item) => !['Ingresada', 'Revision Polaris', 'Adjudicada', 'Remito adjuntado', 'Entregado', 'Solicitud de cambio de costo'].includes(item.state)}
                    />
                </TabSet.Tab>
            </TabSet.Group>
</div>

<style>
    .container {
        width: 100%;
        padding: 50px 70px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        position: relative;
    }
</style>
